export default {
  buttonTitle: {
    en: 'Facebook',
  },
}
